export default [
    {
        audio: 'round1',
        audioGame: 'round1Game',
        similarAnswer: ['Man Down', 'mandown', 'Rihanna'],
        answers: ['Rihanna', 'Beyonce', 'Nicki Minaj', 'Miley Cyrus'],
        rightAnswerIndex: 0,
        songName: '“Man Down” by Rihanna',
        lyrics: `
            What started out as a simple altercation
            Turned into a real sticky situation
            Me just thinking on the time that I’m facing
            Makes me wanna cry
            Cause I didn’t mean to hurt him
            Could’ve been somebody’s son
        `,
        message: `Rihanna sings about how violence can easily escalate and spiral out of control from the smallest of situations. Reflecting on her beliefs and values, she is sharing her regret for reacting and harming someone. The message may be about how important it is for us to reflect and take a moment before reacting. Rihanna might be saying that the consequences of acting with aggression could be very serious.`,
        influence:
            'We could be encouraged to reflect before reacting and approaching others with threats and other bullying behavior. The song could have a positive influence on our choices because it illuminates the value of becoming aware of our emotions and reflecting on our feelings. Sharing stories of prison might be more powerful than just hearing the statistics about bullying behavior.',
    },
    {
        audio: 'round2',
        audioGame: 'round2Game',
        similarAnswer: ['Beautiful', 'Christina', 'Aguilera', 'Christina Aguilera'],
        answers: ['Mariah Carey', 'Leona Lewis', 'Christina Aguilera', 'Ariana Grande'],
        rightAnswerIndex: 2,
        songName: '“Beautiful” by Christina Aguilera',
        lyrics: `
            I am beautiful
            no matter what they say
            Words can’t bring me down
            I am beautiful
            in every single way
            Yes, words can’t bring me down
            So don’t you bring me down today
        `,
        message: `Verbal bullying, put-downs, and name-calling can make one feel threatened, however Aguilera conveys the idea that mindfulness meditation, compassionate and loving acts toward self can calm feelings of fear.`,
        influence: `The song could have a positive influence because it reminds us to have compassion for ourselves. The act of compassion is powerful as it allows us to reflect and not react in fight, flight, or freeze. Aguilera also inspires us to recognize our strengths and validate the struggles that come with dealing with unkind or cruel words.`,
    },
    {
        audio: 'round3',
        audioGame: 'round3Game',
        similarAnswer: ['Brand New Me', 'Alicia Keys', 'Brand', 'Alicia', 'New Me'],
        answers: ['Destiny’s Child', 'Alicia Keys', 'Kelly Rowland', 'Ciara'],
        rightAnswerIndex: 1,
        songName: '“Brand New Me” by Alicia Keys',
        lyrics: `
            It’s been a while,
            I’m not who I was before
            You look surprised,
            Your words don’t burn me anymore
            Been meaning to tell you,
            But I guess it’s clear to see
            Don’t be mad,
            It’s just the brand new kind of me
            Can’t be bad,
            I found a brand new kind of free
        `,
        message: `Alicia sings about meeting a former bully and telling that person that his or her past negative behavior no longer affects her. Keys’ message is that the bullying cycle can be broken—that a target can heal and bystanders can choose not to enlist in the cycle. Keys’ lyric “a new kind of free” could be the feeling of breaking the bullying cycle.`,
        influence: `The song could have a positive influence because Keys expresses a feeling of power from healing and repairing harm. The lyrics could inspire kids to reflect on their values of freedom and kindness and decide not to be a part of the bullying cycle.`,
    },
    {
        audio: 'round4',
        audioGame: 'round4Game',
        similarAnswer: [
            'Drake',
            'One',
            'Ross',
            'Rick Ross',
            'Lil Wayne',
            'Wayne',
            'Khaled',
            'DJ Khaled',
        ],
        answers: ['DJ Khaled', 'J. Cole', 'Travi$ Scott', 'Big Sean'],
        rightAnswerIndex: 0,
        songName: '“I’m On One” by DJ Khaled ft. Drake, Rick Ross, Lil Wayne',
        lyrics: `
            I’m getting so throwed
            I ain’t went this hard since I was 18
            Apologize if I say, anything I don’t mean
            Like what’s up with your best friend?
            We could all have some fun, believe me
        `,
        message: `Drake recounts how he’s been working so hard for so long and when he begins to achieve success, others are still there to be critical and put him down. He apologizes to those whom he’s been short-tempered toward, explaining that he’s been so focused on work that he doesn’t always put the proper effort into maintaining his friendships. The song’s point of view is an example of someone who is part of the bullying cycle and who rationalizes his behavior and therefore keeps the cycle going.`,
        influence: `The lyrics and tone of the song have a negative influence on us because the singer seems to be blaming others and making excuses for his own behavior, instead of repairing the harm. Also, an interesting question is whether Drake infers that he felt a sense of pleasure when he intimidated others in the story. Does he find power in putting others down rather than having empathy? As Drake is a multi-millionare, this message can be a negative influence because kids might think this kind of power can help them achieve financial success.`,
    },
    {
        audio: 'round5',
        audioGame: 'round5Game',
        similarAnswer: ['John Legend', 'Legend', 'Ordinary People', 'Ordinary'],
        answers: ['Robin Thicke', 'Usher', 'Ne-Yo', 'John Legend'],
        rightAnswerIndex: 3,
        songName: '“Ordinary People” by John Legend',
        lyrics: `
            I know I misbehaved
            And you made your mistakes
            And we both still got room left to grow
            And though love sometimes hurts
            I still put you first
            And we’ll make this thing work
            But I think we should take it slow
        `,
        message: `John Legend’s first lyric in the song is, “Girl I’m in love with you.” He makes it clear that the most important thing for him in resolving conflicts is the common belief that there is love between them and that he wants to work through the problems. He sings about his desire to create a non-threatening environment – to be calm, admit wrongs, and confirm love.`,
        influence: `Legend’s honest and forgiving lyrics can have a positive influence on our feeling of frustration while we handle conflicts. Like taking a deep breath, Legend offers practical tools to help create an environment where both parties feel safe and supported. In the song, he tries to let go of expectations, refrains from giving up or exploding, and says that we, too, should ‘take it slow.’`,
    },
    {
        audio: 'round6',
        audioGame: 'round6Game',
        similarAnswer: ['Hollaback Girl', 'Gwen Stefani', 'Gwen', 'Stefani', 'Hollaback'],
        answers: ['Gwen Stefani', 'Fergie', 'Madonna', 'Nelly Furtado'],
        rightAnswerIndex: 0,
        songName: '"Hollaback Girl" by Gwen Stefani',
        lyrics: `
            And you didn’t think that I would hear it.
            People hear you talking like that,
            Getting everybody fired up.
            So I’m ready to attack, gonna lead the pack,
            Gonna get a touchdown, gonna take you out,
            That’s right, put your pom-poms downs,
            Getting everybody fired up.
        `,
        message: `Gwen Stefani sings about a conflict that arises at school after one girl starts rumors about another. The girl whom the rumors are about plans a physical confrontation as payback.`,
        influence: `These lyrics could have a negative influence because they promote the idea that aggression is an acceptable way to solve problems.`,
    },
];
